import styled from 'styled-components';
import { Container, device } from '../mediaQuery';

export const HeroContainer = styled(Container)`
    background-color: lightblue;
    height: 300px;
    max-width: 100vw;
    padding: 0;

    @media ${device.tablet} {
        height: 450px;

    }
    
`;
